import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

function throttle(fn, delay) {
  let last = 0;
  return function (...args) {
    const now = Date.now();
    if (now - last >= delay) {
      last = now;
      fn.apply(this, args);
    }
  };
}

function setSlideMinWidths(swiperEl) {
  const slides = swiperEl.querySelectorAll('.swiper-slide');
  slides.forEach((slide) => {
    slide.style.minWidth = '';
    const width = slide.getBoundingClientRect().width;
    if (width > 0) {
      slide.style.minWidth = width + 55 + 'px';
    }
  });
}

let statsSwiperWr = document.querySelectorAll('.stats-swiper-wr');
statsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(sw) {
          setSlideMinWidths(sw.el);
        },
      },
    });

    const handleResize = throttle(() => {
      setSlideMinWidths(swiperEl);
    }, 200);

    window.addEventListener('resize', handleResize);

    swiperObserver(swiper);
  }
});